export const CaptchaMixin = {
  name: 'CaptchaMixin',

  data: () => {
    return {
      captcha: '',
      isCaptchaChanged: false,
      captchaSource: '/api/captcha',
      objError: {
        captchaError: false,
      },
    };
  },

  computed: {
    c_isCaptchaPristine() {
      return '' === this.captcha;
    },

    c_isCaptchaInvalid() {
      return !this.c_isCaptchaPristine && 6 !== this.captcha.length;
    },

    c_isShowCaptchaInvalid() {
      return this.c_isCaptchaInvalid && this.isCaptchaChanged;
    },

    c_isCaptchaReady() {
      return !this.c_isCaptchaPristine && !this.c_isCaptchaInvalid;
    },
  },

  watch: {
    captcha() {
      this.isCaptchaChanged = false;
    },
  },

  methods: {
    beforeHandleChangeCaptcha() { },

    handleChangeCaptcha() {
      this.beforeHandleChangeCaptcha();
      this.objError.captchaError = false;
      this.isCaptchaChanged = true;
    },

    refresh() {
      this.captchaSource = '/api/captcha?' + Date.now();
    },
  },
};

export default CaptchaMixin;
